/**
 * Axios API hata yanıtından kullanıcıya gösterilecek metin çıkarır.
 */
export function getApiErrorMessage(error) {
  const data = error?.response?.data;
  if (data === "" || data === undefined || data === null) {
    return error?.message?.trim() || null;
  }
  if (typeof data === "string") {
    const s = data.trim();
    return s || null;
  }
  if (typeof data === "object") {
    const candidates = [
      data.message,
      data.Message,
      data.detail,
      data.Detail,
      data.title,
      data.Title,
      data.error,
      data.errorMessage,
      data.ErrorMessage,
    ];
    for (const c of candidates) {
      if (typeof c === "string" && c.trim()) return c.trim();
    }
    if (Array.isArray(data.errors)) {
      const parts = data.errors
        .map((e) =>
          typeof e === "string" ? e : e?.message ?? e?.description ?? "",
        )
        .filter(Boolean);
      if (parts.length) return parts.join(" ");
    }
  }
  return error?.message?.trim() || null;
}
